module.exports = __webpack_public_path__ + "img/kj.4936bee4.png";